import Vue from "vue";
Vue.component("coverage-viewer", {
    props: ["model", "type", "dynamic","showReciprocityMessage"],
    data() {
        return {
            isNoteOpen: null,
            isGeneralNoteOpen: null,
            isReciprocityOpen: null,
            notes: [],
            generalNotes: []          
        };
    },
    computed: {
        descriptionLabel: function () {
            return window.labels.description;
        },
        reciprocityLabel: function () {
            return window.labels.reciprocity;
        }
    },
    methods: {
        openAnnex(annexId) {
            const self = this; 

            self.isNoteOpen = annexId;
            self.$services.notes.getByAnnexId({
                annexId: annexId,
                noteType: window.constants.noteType.note,
                language: window.currentLanguage
            }).then((data) => {
                console.log(data);
                self.notes = data.items;                        
            });
        },
        openGeneralNote() {
            const self = this;            
            self.isGeneralNoteOpen = self.generalNoteAnnexId;
            self.$services.notes.getByAnnexId({
                annexId: self.model.generalNoteAnnexId,
                noteType: window.constants.noteType.note,
                language: window.currentLanguage
            }).then((data) => {
                self.generalNotes = data.items;                                     
            });
        },
		getDocImageFile(document) {
			let fileName = 'doc.png';
			switch (document.language) {
				case 'English':
					fileName = 'doc_en.png';
					break;
				case 'French':
					fileName = 'doc_fr.png';
					break;
				case 'Spanish':
					fileName = 'doc_es.png';
					break;
			}

			return '/images/' + fileName;
		},
		getDocTooltip: function(document) {
			let tooltip = window.labels.llsLinkAlt;
			return tooltip.replace('{0}', document.language);
		}
    },
    template: `        
        
        <section class="card">
			<div class="card-content">                
				<div v-if="model.hasCoverage && model.annexes != null && model.annexes.length > 0">
                    <template v-for="annex in model.annexes">
                        <section class="card">
                            <header class="card-header">
                                <b><i class="pr-2">Extract from {{model.coveragePartyName}}'s coverage commitments set out in</i></b>
					            <a :href="annex.annexLink" target="_blank"><span v-html="annex.annexDescription"></span></a>
					            <a class="browse-annex-lls-link pr-2" v-for="document in annex.documents" :href="document.document" :title="getDocTooltip(document)" target="_blank">
						            <img :src="getDocImageFile(document)" />
					            </a>
                            </header>                                
					        <div class="card-content">
                                <coverage :level="0" :data="annex.coverages"></coverage>
                                <b-collapse v-if="annex.hasReciprocity && showReciprocityMessage"
                                    class="card mb-2"
                                    animation="slide"
                                    :open="isReciprocityOpen == annex.annexId"
                                    @open="isReciprocityOpen = annex.annexId">
                                    <template #trigger="props">
				                        <div class="card-header pt-1 pb-1" role="button">
					                        <i class="fas fa-exclamation-triangle fa-2x has-text-warning mr-3"></i><i class="has-text-weight-bold">{{reciprocityLabel}}</i>
				                        </div>
                                    </template>
                                    <div class="card-content p-1">
				                        <div class="content">
                                            <b-message type="is-success">
                                                <div v-html="annex.reciprocityMessage"></div>
                                            </b-message>					                        
				                        </div>
                                    </div>
                                </b-collapse>
                                <b-collapse
                                    v-if="annex.noteAnnexId != null && annex.noteAnnexId > 0"
                                    class="card mb-2"
                                    animation="slide"
                                    :open="isNoteOpen == annex.noteAnnexId"
                                    @open="openAnnex(annex.noteAnnexId)">
                                    <template #trigger="props">
				                        <div class="card-header pt-1 pb-1" role="button">
					                        <p><b><i class="pr-2">See {{model.coveragePartyName}}'s notes to</i><span class="primary-text" v-html="annex.noteAnnexDescription"></span></b></p>
				                        </div>
                                    </template>
                                    <div class="card-content p-1" v-if="notes != null && notes.length > 0">
				                        <div class="content">
					                        <annex-notes :level="0" :notes="notes"></annex-notes>
				                        </div>
                                    </div>
                                </b-collapse> 
						    </div>
					    </section>                        
                    </template>
				</div>			
				<b-collapse  
					v-if="model.generalNoteAnnexId != null"
		            class="card mb-2"
		            animation="slide"
		            :open="isGeneralNoteOpen"
		            @open="openGeneralNote">
                    <template #trigger="props">
						<div class="card-header pt-1 pb-1" role="button">
                            <p><b><i class="pr-2">See {{model.coveragePartyName}}'s</i><span class="primary-text" v-html="model.generalNoteCaption"></span></b></p>
						</div>
					</template>
					<div class="card-content p-1" v-if="generalNotes != null && generalNotes.length > 0">
						<div class="content">
							<annex-notes :level="0" :notes="generalNotes"></annex-notes>
						</div>
					</div>
	            </b-collapse>					
			</div>
		</section>
	`
});